export const PaymentForm = {
  CREDIT_CARD: "CCR",
};
